import React from 'react'
import { ThemeProvider } from 'styled-components'
import ReactDOM from 'react-dom'
import './index.css'
import App from './app'
import 'antd/dist/antd.css'
import './styles/_override.css'
import { theme } from './styles/_variables'

ReactDOM.render(<ThemeProvider theme={theme}><App /></ThemeProvider>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js